import map20250marzo from 'src/static/svg/calendar/2025/0/marzo.svg'
import map20250abril from 'src/static/svg/calendar/2025/0/abril.svg'
import map20250mayo from 'src/static/svg/calendar/2025/0/mayo.svg'
import map20251marzo from 'src/static/svg/calendar/2025/1/marzo.svg'
import map20251abril from 'src/static/svg/calendar/2025/1/abril.svg'
import map20251mayo from 'src/static/svg/calendar/2025/1/mayo.svg'
import map20252abril from 'src/static/svg/calendar/2025/2/abril.svg'
import map20252mayo from 'src/static/svg/calendar/2025/2/mayo.svg'
import map20253abril from 'src/static/svg/calendar/2025/3/abril.svg'
import map20253mayo from 'src/static/svg/calendar/2025/3/mayo.svg'
import map20253junio from 'src/static/svg/calendar/2025/3/junio.svg'
import map20254mayo from 'src/static/svg/calendar/2025/4/mayo.svg'
import map20254junio from 'src/static/svg/calendar/2025/4/junio.svg'
import map20255mayo from 'src/static/svg/calendar/2025/5/mayo.svg'
import map20255junio from 'src/static/svg/calendar/2025/5/junio.svg'
import map20255julio from 'src/static/svg/calendar/2025/5/julio.svg'
import map20256septiembre from 'src/static/svg/calendar/2025/6/septiembre.svg'
import map20256octubre from 'src/static/svg/calendar/2025/6/octubre.svg'
import map20257octubre from 'src/static/svg/calendar/2025/7/octubre.svg'
import map20257noviembre from 'src/static/svg/calendar/2025/7/noviembre.svg'
import map20258octubre from 'src/static/svg/calendar/2025/8/octubre.svg'
import map20258noviembre from 'src/static/svg/calendar/2025/8/noviembre.svg'
import map20259octubre from 'src/static/svg/calendar/2025/9/octubre.svg'
import map20259noviembre from 'src/static/svg/calendar/2025/9/noviembre.svg'
import map20259diciembre from 'src/static/svg/calendar/2025/9/diciembre.svg'
import map20260enero from 'src/static/svg/calendar/2026/0/enero.svg'
import map20260febrero from 'src/static/svg/calendar/2026/0/febrero.svg'
import map20260marzo from 'src/static/svg/calendar/2026/0/marzo.svg'
import map20261febrero from 'src/static/svg/calendar/2026/1/febrero.svg'
import map20261marzo from 'src/static/svg/calendar/2026/1/marzo.svg'
import map20262febrero from 'src/static/svg/calendar/2026/2/febrero.svg'
import map20262marzo from 'src/static/svg/calendar/2026/2/marzo.svg'
import map20262abril from 'src/static/svg/calendar/2026/2/abril.svg'
import map20263abril from 'src/static/svg/calendar/2026/3/abril.svg'
import map20263mayo from 'src/static/svg/calendar/2026/3/mayo.svg'
import map20263junio from 'src/static/svg/calendar/2026/3/junio.svg'
import map20264abril from 'src/static/svg/calendar/2026/4/abril.svg'
import map20264mayo from 'src/static/svg/calendar/2026/4/mayo.svg'
import map20264junio from 'src/static/svg/calendar/2026/4/junio.svg'
import map20265mayo from 'src/static/svg/calendar/2026/5/mayo.svg'
import map20265junio from 'src/static/svg/calendar/2026/5/junio.svg'
import map20266septiembre from 'src/static/svg/calendar/2026/6/septiembre.svg'
import map20266octubre from 'src/static/svg/calendar/2026/6/octubre.svg'
import map20266noviembre from 'src/static/svg/calendar/2026/6/noviembre.svg'
import map20267octubre from 'src/static/svg/calendar/2026/7/octubre.svg'
import map20267noviembre from 'src/static/svg/calendar/2026/7/noviembre.svg'
import map20268octubre from 'src/static/svg/calendar/2026/8/octubre.svg'
import map20268noviembre from 'src/static/svg/calendar/2026/8/noviembre.svg'
import map20269octubre from 'src/static/svg/calendar/2026/9/octubre.svg'
import map20269noviembre from 'src/static/svg/calendar/2026/9/noviembre.svg'
import map20269diciembre from 'src/static/svg/calendar/2026/9/diciembre.svg'
import map20270febrero from 'src/static/svg/calendar/2027/0/febrero.svg'
import map20270marzo from 'src/static/svg/calendar/2027/0/marzo.svg'
import map20271febrero from 'src/static/svg/calendar/2027/1/febrero.svg'
import map20271marzo from 'src/static/svg/calendar/2027/1/marzo.svg'
import map20271abril from 'src/static/svg/calendar/2027/1/abril.svg'
import map20272marzo from 'src/static/svg/calendar/2027/2/marzo.svg'
import map20272abril from 'src/static/svg/calendar/2027/2/abril.svg'
import map20273abril from 'src/static/svg/calendar/2027/3/abril.svg'
import map20273mayo from 'src/static/svg/calendar/2027/3/mayo.svg'
import map20274abril from 'src/static/svg/calendar/2027/4/abril.svg'
import map20274mayo from 'src/static/svg/calendar/2027/4/mayo.svg'
import map20274junio from 'src/static/svg/calendar/2027/4/junio.svg'
import map20275mayo from 'src/static/svg/calendar/2027/5/mayo.svg'
import map20275junio from 'src/static/svg/calendar/2027/5/junio.svg'
import map20276septiembre from 'src/static/svg/calendar/2027/6/septiembre.svg'
import map20276octubre from 'src/static/svg/calendar/2027/6/octubre.svg'
import map20276noviembre from 'src/static/svg/calendar/2027/6/noviembre.svg'
import map20277octubre from 'src/static/svg/calendar/2027/7/octubre.svg'
import map20277noviembre from 'src/static/svg/calendar/2027/7/noviembre.svg'
import map20278octubre from 'src/static/svg/calendar/2027/8/octubre.svg'
import map20278noviembre from 'src/static/svg/calendar/2027/8/noviembre.svg'

export default {
  map20250marzo,
  map20250abril,
  map20250mayo,
  map20251marzo,
  map20251abril,
  map20251mayo,
  map20252abril,
  map20252mayo,
  map20253abril,
  map20253mayo,
  map20253junio,
  map20254mayo,
  map20254junio,
  map20255mayo,
  map20255junio,
  map20255julio,
  map20256septiembre,
  map20256octubre,
  map20257octubre,
  map20257noviembre,
  map20258octubre,
  map20258noviembre,
  map20259octubre,
  map20259noviembre,
  map20259diciembre,
  map20260enero,
  map20260febrero,
  map20260marzo,
  map20261febrero,
  map20261marzo,
  map20262febrero,
  map20262marzo,
  map20262abril,
  map20263abril,
  map20263mayo,
  map20263junio,
  map20264abril,
  map20264mayo,
  map20264junio,
  map20265mayo,
  map20265junio,
  map20266septiembre,
  map20266octubre,
  map20266noviembre,
  map20267octubre,
  map20267noviembre,
  map20268octubre,
  map20268noviembre,
  map20269octubre,
  map20269noviembre,
  map20269diciembre,
  map20270febrero,
  map20270marzo,
  map20271febrero,
  map20271marzo,
  map20271abril,
  map20272marzo,
  map20272abril,
  map20273abril,
  map20273mayo,
  map20274abril,
  map20274mayo,
  map20274junio,
  map20275mayo,
  map20275junio,
  map20276septiembre,
  map20276octubre,
  map20276noviembre,
  map20277octubre,
  map20277noviembre,
  map20278octubre,
  map20278noviembre
}